export default "__VITE_ASSET__8GRP44GQ__"